import { FunctionComponent } from 'react'

import useIsAuthResolved from '@hooks/useIsAuthResolved'
import DrawerPortal, {
  DrawerPortalProps,
} from '@components/Drawer/DrawerPortal'

import FollowMyTeamMyTeams from '../FollowMyTeamMyTeams'
import FollowMyTeamSelectTeam from '../FollowMyTeamSelectTeam'

export type FollowMyTeamDrawerProps = Pick<DrawerPortalProps, 'onClose'> & {
  openAt?: 'showSelectTeam' | 'showMyTeams'
}

const FollowMyTeamDrawer: FunctionComponent<FollowMyTeamDrawerProps> = ({
  openAt,
  onClose,
}) => {
  const isAuthResolved = useIsAuthResolved()

  const normalizedOpenAt = !isAuthResolved ? undefined : openAt

  return (
    <DrawerPortal direction="right" open={!!normalizedOpenAt} onClose={onClose}>
      {normalizedOpenAt === 'showSelectTeam' && (
        <FollowMyTeamSelectTeam onClose={onClose} />
      )}
      {normalizedOpenAt === 'showMyTeams' && (
        <FollowMyTeamMyTeams onClose={onClose} />
      )}
    </DrawerPortal>
  )
}

export default FollowMyTeamDrawer
